module.exports = __webpack_public_path__ + "static/media/tapbrick-1.8b85f183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tapbrick-1.jpg
// module id = 109
// module chunks = 0